import { createVertexOverrides } from 'JS/utilities/vertex';
require('./account-helpers');

Blain.CustomerCreditCard = {

	initCreditCardList: function (selector) {

		if (!selector || selector.length === 0) return;

		const self = this;

		$(selector).find("a.edit-card").off("click.edit").on("click.edit", function (e) {
			const recId = $(this).attr("data-blain-recid");
			e.preventDefault();
			self.getCreditCardModal(null, recId);
		});

		Blain.AccountHelpers.initDeleteWithConfirm({
			deleteLinkObject: $(selector).find("a.del-card"),
			modalText: "Are you sure you wish to delete this credit card?",
			urlRoute: "creditcard-remove",
			dataProperties: {
				profileID: "blain-recid"
			},
			partialViews: {
				creditCards: "CreditCardListHtmlString"
			},
			callbackFunction: function() {
				self.initCreditCardList(selector);
			}
		});
	},

	getCreditCardModal: function (headerText, profileID) {
		const self = this;
		const $creditCardModal = $("#creditCardModal");
		const $creditCardProgress = $("#creditCardProgress");
		const $creditCardFormContainer = $("#creditCardFormContainer");
		const $creditCards = $("#creditCards");

		$creditCardModal.blainModal("show");
		$creditCardModal.off("blainmodal.hidden").on("blainmodal.hidden", function () {
			$creditCardProgress.show();
			$creditCardFormContainer.hide().empty();
		});


		//------------------------
		// Track card type changes
		//------------------------
		$(document).off("cardTypeFound").on("cardTypeFound", function (e, cardType) {
			self.cardType = cardType;
		});

		$.ajax({
			type: "POST",
			url: "/account/creditcardform",
			dataType: "json",
			data: JSON.stringify({
				profileID: profileID,
				headerText: headerText
			}),
			contentType: "application/json",
			error: function (xhr) {
				const obj = $.parseAjaxError(xhr);
				$creditCardModal.blainModal("hide");
				$.globalAjaxError(obj);
			},
			success: function (data) {
				if ( !data.Success ) {
					if ( !data.CurrentSession ) {
						window.location = "/account/verify/?refUrl=%2faccount%2fcustomerinfo";
						return;
					}

					$creditCards.html(data.CreditCardListHtmlString);
					$.modalMsg({
						message: "Sorry, but the credit card appears to be removed. Please try again."
					});
					return;
				}

				$creditCardProgress.hide();
				$creditCardFormContainer.html(data.HtmlString).show();
				$creditCardFormContainer.find('input').first().focus();

				const $creditCardForm = $("#creditCardForm");
				const $creditCardAlert = $("#creditCardAlert");
				const $creditCardAlertText = $("#creditCardAlertText");
				const $ccExpDate = $("#ccExpDate");
				const $ccCsExpDate = $("#ccCsExpDate");
				const $ccCsCardType = $("#ccCsCardType");

				$creditCardForm.validate({
					rules: {
						ccExpDate: {
							required: true,
							expdate: true
						}
					},
					submitHandler: function () {

						$creditCardFormContainer.hide();
						$creditCardProgress.show();

						// Reformat expiration date into hidden field
						const tmp = $ccExpDate.val().split("/");
						if (tmp.length === 2) {
							// CyberSource expects the format `MM-YYYY`. if month is only a single
							// digit, it must have a leading 0, otherwise, they respond with a failure
							const month = tmp[0].padStart(2, '0');
							const year = "20" + tmp[1];
							$ccCsExpDate.val(month + "-" + year);
						}

						// Set up listener for CyberSource response
						$(document).one("blain.csresponse", function (e, csresult) {

							switch (csresult) {
								case "Success":
									// Profile updated - refresh the credit card list and close the modal
									$.ajax({
										type: "POST",
										url: "/account/creditcardlist",
										dataType: "json",
										error: function(xhr) {
											const obj = $.parseAjaxError(xhr);
											$creditCardModal.blainModal("hide");
											$.globalAjaxError(obj);
										},
										success: function(d) {
											$creditCardModal.blainModal("hide");
											$creditCards.html(d.CreditCardListHtmlString);
											self.initCreditCardList($creditCards);
										}
									});
									return;
								case "CardNotAccepted":
									$creditCardAlertText.text("Sorry, we do not accept this card type.");
									break;
								case "CardDeclined":
									$creditCardAlertText.text("Sorry, this credit card has been declined.");
									break;
								default:
									$creditCardAlertText.text("Information was not accepted by the payment network. If you continue to have trouble, please contact Customer Service at " + Blain.customerServicePhone + ".");
									break;
							}

							// Show alert for non-success situations
							$creditCardProgress.hide();
							$creditCardAlert.show();
						});
						// Load the iframe
						$('<iframe class="csiframe" src="https://' + location.hostname + '/cs/update/?profileID=' + encodeURIComponent(profileID) + '"></iframe>').appendTo($("body"));
					}
				});

				$("#ccCancel").on("click", function (e) {
					e.preventDefault();
					$creditCardModal.blainModal("hide");
				});

				Blain.Forms.initFormsTooltips($creditCardForm.find("input, select"));
				Blain.Forms.initMaskedInputs($creditCardForm);
			}
		});
	},
};

Blain.CustomerAddress = {
	initAddressBook: function (selector) {

		if (!selector || selector.length === 0) return;

		const self = this;

	    const $overflowAddresses = $(".overflow");
	    const $viewAll = $(".view-all", selector);

		$viewAll.off("click").on("click", function () {
			if ($overflowAddresses.is(":visible")) {
				$overflowAddresses.css("display", "none");
				$viewAll.text("View All Addresses >");
			} else {
				$overflowAddresses.removeAttr("style");
				$viewAll.text("Hide Addresses >");
			}
		});

		$(selector).find("a.add-addr").off("click.add").on("click.add", function (e) {
			e.preventDefault();
			self.getAddressModal(null);
		});

		$(selector).find("a.edit-addr").off("click.edit").on("click.edit", function (e) {
			const recId = $(this).data("blain-recid");
			e.preventDefault();
			self.getAddressModal(null, recId);
		});

		Blain.AccountHelpers.initDeleteWithConfirm({
			deleteLinkObject: $(selector).find("a.del-addr"),
			modalText: "Are you sure you wish to delete this address?",
			urlRoute: "address-remove",
			dataProperties: {
				addressID: "blain-recid"
			},
			partialViews: {
				addressBook: "AddressBookHtmlString"
			},
			callbackFunction: function() {
				self.initAddressBook(selector);
			}
		});
	},

	// Do an update of a tax profile
	doUpdateAddress: function(customerAddressObj, callbackFunction) {
		$.ajax({
			type: "POST",
			contentType: "application/json; charset=utf-8",
			dataType: "json",

			url: "/account/address-update",
			data: JSON.stringify(customerAddressObj),
			success: function (data) {
				if ( !data.Success ) {
					if ( !data.CurrentSession ) {
						window.location = "/account/verify/?refUrl=%2faccount%2faddresses";
						return;
					}
				}
				callbackFunction(data);
			},
			error: function (xhr) {
				callbackFunction({
					Success: false,
					HttpFailure: $.parseAjaxError(xhr)
				});
			}
		});
	},

	getAddressModal: function (headerText, addressID = 0) {
		const self = this;
		const $customerAddressModal = $("#customerAddressModal");
		const $customerAddressProgress = $("#customerAddressProgress");
		const $customerAddressFormContainer = $("#customerAddressFormContainer");
		const $addressBook = $("#addressBook");

		$customerAddressModal.blainModal("show");
		$customerAddressModal.off("blainmodal.hidden").on("blainmodal.hidden", function () {
			$customerAddressProgress.show();
			$customerAddressFormContainer.hide().empty();
		});

		$.ajax({
			type: "POST",
			url: "/account/addressform",
			dataType: "json",
			data: JSON.stringify({
				addressID: addressID,
				headerText: headerText
			}),
			contentType: "application/json",
			error: function (xhr) {
				const obj = $.parseAjaxError(xhr);
				$customerAddressModal.blainModal("hide");
				$.globalAjaxError(obj);
			},
			success: function (data) {
			    if ( !data.Success ) {
					if ( !data.CurrentSession ) {
						window.location = "/account/verify/?refUrl=%2faccount%2faddresses";
						return;
					}

					$addressBook.html(data.AddressBookHtmlString);
					$.modalMsg({
						message: "Sorry, but the address appears to be removed. Please try again."
					});
					return;
				}

				const $form = $(data.HtmlString);
				// Wire up the form contents and validation
				const $customerAddressForm = $form;
				const $customerAddressAlert = $form.find("#customerAddressAlert");
				const $addrFirstName = $form.find("#addrFirstName");
				const $addrLastName = $form.find("#addrLastName");
				const $addrCompany = $form.find("#addrCompany");
				const $addrAddress1 = $form.find("#addrAddress1");
				const $addrAddress2 = $form.find("#addrAddress2");
				const $addrZip = $form.find("#addrZip");
				const $addrSetDefault = $form.find("#addrSetDefault");

				$form.find("#addrCancel").on("click", function(e) {
					e.preventDefault();
					$customerAddressModal.blainModal("hide");
				});

				$customerAddressProgress.hide();
				$customerAddressFormContainer.html($customerAddressForm).show();

				Blain.AccountHelpers.initDeleteWithConfirm({
					deleteLinkObject: $("#addrDelete"),
					modalText: "Are you sure you wish to delete this address?",
					urlRoute: "address-remove",
					dataProperties: {
						addressID: "blain-recid"
					},
					partialViews: {
						addressBook: "AddressBookHtmlString"
					},
					onYes: function() {
						$customerAddressModal.blainModal("hide");
					},
					callbackFunction: function (d) {
						self.initAddressBook($addressBook);
						$(document).trigger("blain.addressdone", d);
					}
				});

				$addrFirstName[0].select();

				$customerAddressForm.validate({
					rules: {
						addrZip: {
							required: true,
							digits: true,
							minlength: 5,
							maxlength: 5,
							remote: {
								type: "POST",
								url: "/a/autocitystate",
								data: {
									zipCode: function() {
										return $addrZip.val();
									},
									selectID: "addrCity2",
									selectName: "addrCity2"
								},
								dataFilter: function(jsonstr) {
									const json = JSON.parse(jsonstr);
									if (json.Success) {
										$("#addrCity2").replaceWith(json.CityListHtmlString);
										return '"true"';
									}
									return '"ZIP code is invalid"';
								}
							}
						}
					},
					messages: {
						addrZip: {
							remote: "ZIP code is invalid"
						}
					},
					submitHandler: function () {

						$customerAddressFormContainer.hide();
						$customerAddressProgress.show();
						const $addrCity2 = $("#addrCity2");

						const customerAddressObj = {
							firstName: $addrFirstName.val(),
							lastName: $addrLastName.val(),
							company: $addrCompany.val(),
							address1: $addrAddress1.val(),
							address2: $addrAddress2.val(),
							city: $addrCity2.val(),
							state: $addrCity2.data("blain-state"),
							zip: $addrZip.val(),
							setDefault: $addrSetDefault.is(":checked"),
							addressID: addressID
						};

						self.doUpdateAddress(customerAddressObj, function (d) {
							if (!d.Success) {

								if (d.HttpFailure) {
									$customerAddressModal.blainModal("hide");
									$.globalAjaxError(d.HttpFailure);
									return;
								}

								if (d.AddressLimit) {
									$customerAddressModal.blainModal("hide");
									$.modalMsg({
										title: "Addressbook Limit Reached",
										msg: "Sorry, but you can only have up to 10 addresses in your addressbook. Please remove another address before attempting to add a new one."
									});
									return;
								}

								$customerAddressAlert.show();
								$customerAddressFormContainer.show();
								$customerAddressProgress.hide();
								return;
							}

							$addressBook.html(d.AddressBookHtmlString);
							$customerAddressModal.blainModal("hide");

							$(document).trigger("blain.addressdone", d);
							self.initAddressBook($addressBook);
						});
					}
				});
				Blain.Forms.initFormsTooltips($customerAddressForm.find("input"));
				Blain.Forms.initMaskedInputs($customerAddressForm);
			}
		});
	},
};

Blain.CustomerInfo = {

	get isMobile() {
		const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
		return width < 767;
	},

	initCustomerInfo: function (selector) {
		if (!selector || selector.length === 0) return;
		const self = this;
		$(selector).find("a.edit-account").off("click.edit").on("click.edit", function (e) {
			e.preventDefault();
			self.getCustomerInfoModal();
		});
	},

	initAccountTabNavigation: function () {
		const $signOut = $("#signout-btn");
		$signOut.off("click").on("click", function (e) {
			e.preventDefault();
		});

		$("#mobileBackToTopBtn").off("click").on("click", function () {
			window.scrollTo({
				top: 0,
				behavior: "smooth"
			});
		});

		const shouldScroll = location.href.includes('account/rewards') || location.href.includes('account/orders');
		if (this.isMobile && shouldScroll) {
			window.scrollTo({
				top: 460,
				behavior: "smooth"
			});
		}

		const tabs = document.querySelectorAll('.tab-container');
		if (tabs) {
			tabs.forEach(tab => tab.addEventListener('click', e => {
				// Use regular navigation if on order results screen
				if (Blain.CustomerInfo.isOnOrderSearchResults()) {
					return;
				}

				e.preventDefault();
				switchTab(tab.id);
				if (this.isMobile) {
					window.scrollTo({
						top: 460,
						behavior: "smooth"
					});
				}

			}));
		}

		const sectionsByTab = {
			rewardsTab: { screenId: 'blainsRewards', area: "rewards/" },
			ordersTab: { screenId: 'orderList', area: "orders/" },
			subscriptionsTab: { screenId: 'subscriptionList', area: "subscriptions/" },
			appointmentsTab: { screenId: 'appointmentList', area: "appointments/" },
			giftcardsTab: { screenId: 'giftCards', area: "giftcards/" },
			addressesTab: { screenId: 'addressBook', area: "addresses/" },
			storeTab: { screenId: 'myStore', area: "mystore/" },
			blainccTab: { screenId: 'blainsCC', area: "blainsCC/" },
			customerTab: { screenId: 'customerInfo', area: "customerinfo/" },
			taxExemptTab: { screenId: 'taxExempt', area: "taxexempt/" },
			homeTab: { screenId: "accountHome", area: "" },
		};

		function getCurrentTabId() {
			return Array.from(tabs).find(t => t.getAttribute('aria-selected') === 'true')?.id;
		}

		function switchTab(nextTabId) {
			const prevTabId = getCurrentTabId();
			// We need to initialize the history state with the current tab so we
			// can nav back to the tab that's active on page load
			if (prevTabId && !history.state?.accountTabId) {
				history.replaceState({ accountTabId: prevTabId });
			}

			const { screenId, area } = sectionsByTab[nextTabId] || sectionsByTab.homeTab;

			/** @type {NodeListOf<HTMLElement>} **/
			const screens = document.querySelectorAll('.act-section');
			screens.forEach(screen => {
				const isSelected = screenId === screen.id;
				screen.style.setProperty('display', isSelected ? 'block' : 'none');
				if (isSelected) {
					screen.querySelector('input, a, button')?.focus();
				}
			});

			tabs.forEach(tab => {
				const selected = tab.id === nextTabId;
				tab.classList.toggle('active', selected);
				tab.setAttribute('aria-selected', selected ? 'true' : 'false');
			});

			if (history.state?.accountTabId !== nextTabId) {
				history.pushState({ accountTabId: nextTabId }, '', `/account/${area}`);
			}

			if (nextTabId !== prevTabId) {
				// This is used by a couple of Vue apps mounted within account tabs to kick off
				// AJAX requests once shown
				window.dispatchEvent(new CustomEvent('accounttabchange', {
					detail: area,
				}));
			}
		};

		window.addEventListener('popstate', e => {
			const tabId = e.state?.accountTabId;
			if (tabId) {
				switchTab(tabId);
			}
		});

	},

	isOnOrderSearchResults: function() {
		const { search, pathname } = window.location;
		return (
			pathname.indexOf('account/orders') > -1
			&& typeof search === 'string'
			&& search.indexOf('q=') > -1
		);
	},

	// Do an update of a tax profile
	doUpdateCustomerInfo: function (customerInfoObj, callbackFunction) {
		$.ajax({
			type: "POST",
			contentType: "application/json; charset=utf-8",
			dataType: "json",

			url: "/account/customerinfo-update",
			data: JSON.stringify(customerInfoObj),
			success: function (data) {
				if ( !data.success ) {
					if ( !data.CurrentSession ) {
						window.location = "/account/verify/?refUrl=%2faccount%2fcustomerinfo";
						return;
					}
				}
				callbackFunction(data);
			},
			error: function (xhr) {
				callbackFunction({
					Success: false,
					HttpFailure: $.parseAjaxError(xhr)
				});
			}
		});
	},

	getCustomerInfoModal: function () {
		const self = this;
		const $customerInfoModal = $("#customerInfoModal");
		const $customerInfoProgress = $("#customerInfoProgress");
		const $customerInfoFormContainer = $("#customerInfoFormContainer");
		const $customerInfo = $("#customerInfo");

		$customerInfoModal.blainModal("show");
		$customerInfoModal.off("blainmodal.hidden").on("blainmodal.hidden", function () {
			$customerInfoProgress.show();
			$customerInfoFormContainer.hide().empty();
		});

		$.ajax({
			type: "POST",
			url: "/account/customerinfoform",
			dataType: "json",
			contentType: "application/json",
			error: function (xhr) {
				const obj = $.parseAjaxError(xhr);
				$customerInfoModal.blainModal("hide");
				$.globalAjaxError(obj);
			},
			success: function (data) {
				if ( !data.Success ) {
					if ( !data.CurrentSession ) {
						window.location = "/account/verify/?refUrl=%2faccount%2fcustomerinfo";
						return;
					}
				}
				// Wire up the form contents and validation
				$customerInfoProgress.hide();
				$customerInfoFormContainer.html(data.HtmlString).show();
				const $customerInfoForm = $("#customerInfoForm");
				const $customerInfoAlert = $("#customerInfoAlert");
				const $customerInfoAlertText = $("#customerInfoAlertText");
				const $ciFirstName = $("#ciFirstName");
				const $ciLastName = $("#ciLastName");
				const $ciPhone = $("#ciPhone");
				const $ciEmail = $("#ciEmail");
				const $ciNewPassword = $("#ciNewPassword");
				const $ciShowPassword = $("#ciShowPassword");

				//addPasswordStrengthValidation($ciNewPassword.parent());

				$("#ciCancel").on("click", function (e) {
					e.preventDefault();
					$customerInfoModal.blainModal("hide");
				});

				$ciShowPassword.on("click.toggle", function () {
					const type = $(this).is(":checked") ? "text" : "password";
					$ciNewPassword.attr("type", type);
				});

				$ciFirstName[0].select();

				$customerInfoForm.validate({
					submitHandler: function () {

						$customerInfoFormContainer.hide();
						$customerInfoProgress.show();

						const customerInfoObj = {
							firstName: $ciFirstName.val(),
							lastName: $ciLastName.val(),
							phone: $ciPhone.val(),
							emailAddress: $ciEmail.val(),
							password: $ciNewPassword.val()
						};

						self.doUpdateCustomerInfo(customerInfoObj, function (d) {
							if (!d.success) {

								if (d.HttpFailure) {
									$customerInfoModal.blainModal("hide");
									$.globalAjaxError(d.HttpFailure);
									return;
								}

								if (d.duplicateEmail) $customerInfoAlertText.text("Email address already in use by another account.");
								else $customerInfoAlertText.text("Required fields are missing.");

								$customerInfoAlert.show();
								$customerInfoFormContainer.show();
								$customerInfoProgress.hide();
								return;
							}

							$customerInfoModal.blainModal("hide");

							$customerInfo.html(d.customerInfoHtmlString);

							// update header
							if (d.headerJson && window.vueEventBus) {
								window.vueEventBus.$emit('header-vm', d.headerJson);
							}

							// Update side name in sidebar:
							const $sidebarHeader = $('#act-sb-header-text');
							$sidebarHeader.text("Hello, " + d.headerJson.customer.firstName);

							self.initCustomerInfo($customerInfo);
						});
					}
				});

				Blain.Forms.initFormsTooltips($customerInfoForm.find("input"));
				Blain.Forms.initMaskedInputs($customerInfoForm);
			}
		});
	},
};

Blain.AccountHome = {
	init: function () {
		if (!document.getElementById("accountHome")) return;
		Blain.Rewards.initRewardsSidePanel();
		$("#accountHome .rjLink").off("click").on("click", function (e) {
			Blain.Rewards.showJoinRewardsSidePanel("connect");
		});
		$("#accountHome .rjAccept").off("click").on("click", function (e) {
			Blain.Rewards.showJoinRewardsSidePanel();
		});
	}
};

Blain.TaxExemption = {
	init: function () {
		if (window.vertex) {
			this.loadECWizard();
		} else {
			window.addEventListener('ecwizard-loaded', () => {
				this.loadECWizard();
			});
		}
	},

	loadECWizard: function () {
		const el = document.querySelector('#ecWizard-button');
		if (el) {
			const options = JSON.parse(el.dataset.options);
			if (!window.vertex || !options.accessToken) {
				return;
			}

			// Configure the wizard
			const btn = new window.vertex.Wizard({
				domNode: document.getElementById('ecWizard-button'),
				wizardPath: 'https://ccwizard.vertexsmb.com/',
				accessToken: options.accessToken,
				actionType: "Create",
				sellerCodes: [options.sellerCode],
				buyerCode: options.customerCode,
				overrides: createVertexOverrides(options),
			});

			const attachUrl = el.dataset.attachUrl ?? '/account/certificate-attach';

			// Add an event listener to get notifications when a certificate is created
			window.addEventListener("message", function (event) {
				if (event.data && event.data.type == 'createdCertificates') {
					for (let i = 0; i < event.data.data.length; i++) {
						$.ajax({
							type: "POST",
							url: attachUrl,
							dataType: "json",
							data: JSON.stringify({
								certificateId: event.data.data[i].id,
								buyerCode: event.data.data[i].buyerCode
							}),
							contentType: "application/json"
						});
					}
				}
			});

			// CertificateFormMobile.cshtml listens for this so that it can
			// automatically open the vertex modal, once configured.
			window.dispatchEvent(new CustomEvent('blain-ecwizard-configured'));
		}
	}
};